import React from "react";
import DisplayIndex2 from "../display2/DisplayIndex";
import { useRemoteScreen } from "util/useRemoteScreen";

import {
  defaultDisplayState,
  getDisplayStateFromSearch,
} from "../display2/DisplaySettingsProvider";

const RemoteIndex = () => {
  const remoteScreen = useRemoteScreen();

  const state = React.useMemo(() => {
    return remoteScreen?.search
      ? getDisplayStateFromSearch(remoteScreen?.search)
      : defaultDisplayState;
  }, [remoteScreen?.search]);

  return <DisplayIndex2 stateOverride={state} />;
};

export default RemoteIndex;
